module.exports = __webpack_public_path__ + "img/goods-left.df1afd35.png";